import useHomeType from 'hooks/useHomeType'
import RotaBuilder from '../RotaBuilder/RotaBuilder'

export const RotaBuilderScreen = () => {
  const { hasRota } = useHomeType()

  if (!hasRota) {
    return null
  }

  return <RotaBuilder />
}
